import valid from 'card-validator'
import elo from 'creditcards-types/types/elo'

export const cvcRequired = value => (value ? undefined : 'Digite o código.')
export const validateCreditCard = value => {
  const numberValidation = valid.number(value)
  return numberValidation.isPotentiallyValid ? undefined : 'Cartão de crédito inválido.'
}

export const validateCreditCardFlag = value => {
  const numberValidation = valid.number(value)
  return numberValidation.isPotentiallyValid
    ? validElo(value)
      ? 'elo'
      : (numberValidation.card && numberValidation.card.type === 'mastercard') ||
        (numberValidation.card && numberValidation.card.type === 'master-card')
        ? 'master'
        : numberValidation.card && numberValidation.card.type === 'american-express'
          ? 'amex'
          : numberValidation.card && numberValidation.card.type
    : undefined
}

export const validElo = cardNum => {
  if (!cardNum) {
    return undefined
  }
  const card = cardNum.replace(/[\s+|\.|\-]/g, '') // eslint-disable-line
  return elo.test(card)
}



// WEBPACK FOOTER //
// ./src/app/modules/EditPaymentForm/validators.js